import { m as map } from '../Either-48abb652.js';
import { p as pipe } from '../ReadonlyNonEmptyArray-0e481d0b.js';
import { CollapsibleListData_InitialExpandedItems, CollapsibleListData_Direction, Node_Type } from 'ricos-schema';
import { addNode } from './builder-utils.js';
import { DEFAULT_CONTAINER_DATA, createNode } from './node-builder-methods.js';
import 'lodash';
import '../fp-utils-24a5cc96.js';
import './modify.js';
import '../modifier-infra.js';
import '../index-a60c253d.js';
import '../ReadonlyRecord-86a56753.js';
import '../string-40bcd6bf.js';
import '../converters/generateRandomId.js';
import 'ricos-schema/dist/statics/bulleted_list.defaults.json';
import 'ricos-schema/dist/statics/ordered_list.defaults.json';
import '../converters/nodeUtils.js';
import 'uuid';
import '../utils.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const DEFAULT_COLLAPSIBLE_LIST_DATA = {
  initialExpandedItems: CollapsibleListData_InitialExpandedItems.FIRST,
  direction: CollapsibleListData_Direction.LTR,
  containerData: DEFAULT_CONTAINER_DATA,
  expandOnlyOne: false
};
const toCollapsibleItemNode = (generateId) => (item) => createNode(
  generateId
)(Node_Type.COLLAPSIBLE_ITEM, {}, [
  createNode(generateId)(
    Node_Type.COLLAPSIBLE_ITEM_TITLE,
    {},
    item.title.nodes
  ),
  createNode(generateId)(
    Node_Type.COLLAPSIBLE_ITEM_BODY,
    {},
    item.content.nodes
  )
]);
const toCollapsibleListNode = (generateId) => (data = DEFAULT_COLLAPSIBLE_LIST_DATA) => (nodes) => createNode(generateId)(
  Node_Type.COLLAPSIBLE_LIST,
  data,
  nodes
);
const toContentWithCollapsibleList = (args) => (node) => addNode(__spreadProps(__spreadValues({}, args), { node }));
const makeCollapsibleList = (generateId) => ({
  items,
  data
}) => {
  return pipe(
    items,
    map(toCollapsibleItemNode(generateId)),
    toCollapsibleListNode(generateId)(data)
  );
};
const addCollapsibleList = (generateId) => ({
  items,
  data,
  index,
  before,
  after,
  content
}) => {
  return pipe(
    makeCollapsibleList(generateId)({ items, data }),
    toContentWithCollapsibleList({ index, before, after, content })
  );
};

export { addCollapsibleList, makeCollapsibleList };
//# sourceMappingURL=collapsible-list-builder-api.js.map
